<div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-sm-12">
            <h1>Forbidden</h1>
            <h2 class="text-danger">You have no rights to access the application.</h2>
        </div>
    </div>
</div>
